import { DateUtils } from 'react-day-picker';

const isDayAfter = (day1: Date, day2: Date) => DateUtils.isDayAfter(day1, day2);

export default isDayAfter;
